// removed by extract-text-webpack-plugin
module.exports = {"button":"_3xlQE","createButton":"s7J_4","page":"eByZ5","user":"_4tU6W","userDisabled":"_3Vl-3 _4tU6W","name":"FcscJ","email":"jWLCk","permList":"_3QzN4","perm":"_2YGHN","permSuperAdmin":"_2AxPl _2YGHN","heading":"_2CY4E","notes":"_3v89W"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Users.css
// module id = 867
// module chunks = 0